import React, { useEffect, useRef, useState } from "react";

const TurnstileWrapper = ({
  onChange, captchaKey, setTurnstileInteractive, onError,
}) => {
  const scriptSrc = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  const containerRef = useRef(null);
  const [isReadyToRender, setIsReadyToRender] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);

  // Bind window functions with cleanup
  useEffect(() => {
    window.onVerifyTurnstile = (token) => {
      setTurnstileToken(token);
      onChange(token);
    };
    window.onTurnstileError = (error) => onError?.(error);
    window.setTurnstileIsInteractive = () => setTurnstileInteractive(true);
    window.setTurnstileNotInteractive = () => setTurnstileInteractive(false);

    return () => {
      delete window.onVerifyTurnstile;
      delete window.onTurnstileError;
      delete window.setTurnstileIsInteractive;
      delete window.setTurnstileNotInteractive;
    };
  }, [onChange, setTurnstileInteractive, onError]);

  useEffect(() => {
    if (containerRef.current) {
      setIsReadyToRender(true);
    }
  }, []);

  // Append Turnstile script only when container is visible and not already injected
  useEffect(() => {
    if (!isReadyToRender) { return; }

    if (!document.querySelector(`script[src='${scriptSrc}']`)) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      document.head.appendChild(script);
    }
  }, [isReadyToRender]);

  return (
    <>
      <div
        ref={containerRef}
        className="cf-turnstile"
        data-sitekey={captchaKey}
        data-callback="onVerifyTurnstile"
        data-error-callback="onTurnstileError"
        data-appearance="interaction-only"
        data-before-interactive-callback="setTurnstileIsInteractive"
        data-after-interactive-callback="setTurnstileNotInteractive"
      />
      <input type="hidden" name="cf-turnstile-response" value={turnstileToken} />
    </>
  );
};

export default TurnstileWrapper;
